import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 10px;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const IconMaia = styled.img`
  ${({ theme }) => css`
    height: 32px;
    width: 32px;
  
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 20px;
      width: 20px;
    }
  `}
`;

export const InputHeadText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 24px 0;
  `}
`;

export const ButtonWrapper = styled.div`
  margin: 32px 0;
`;

export const TextFieldWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    width: 100%;

    button > svg {
      fill: ${theme.v2.colors.neutral.lowPure};
    }
  `}
`;

export const AutoComplete = styled.ul`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    height: auto;
    margin: 0px;
    max-height: 140px;
    overflow-y: auto;
    padding: 0px;
    position: absolute;
    top: 60px;
    width: 100%;
    z-index: ${theme.v2.layers.important};

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPrimary};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highDark};
      border-radius: 25px;
      height: 30px;
      width: 8px;
    }
  `}
`;

export const AutoCompleteItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    padding: 8px 16px;

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryBlue};
      color: ${theme.v2.colors.neutral.highPure};
    }
  `}
`;
